module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": _vm.nameOfPicker,
      "value": ""
    }
  })
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-0006128e", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0006128e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/reusables/DateRangePicker.vue
// module id = 1404
// module chunks = 1